// extracted by mini-css-extract-plugin
export default {"noTabs":"CreateProject-module__noTabs____OO9w"};